import { logWarning } from '@grafana/runtime';
import { SemVer } from 'semver';

const LLM_PLUGIN_ID = "grafana-llm-app";
const LLM_PLUGIN_ROUTE = `/api/plugins/${LLM_PLUGIN_ID}`;
let LLM_PLUGIN_VERSION = new SemVer("0.2.0");
function setLLMPluginVersion(version) {
  try {
    LLM_PLUGIN_VERSION = new SemVer(version);
  } catch (e) {
    logWarning("Failed to parse version of grafana-llm-app; assuming old version is present.");
  }
}

export { LLM_PLUGIN_ID, LLM_PLUGIN_ROUTE, LLM_PLUGIN_VERSION, setLLMPluginVersion };
//# sourceMappingURL=constants.js.map
